<template>
  <w-sliding-popup type="setting" ref="slidingPopup" width="500px" @close="close" title="수집 서버 설정">
    <div slot="content">
      <!-- Content -->
      <div class="title-h4 title-bar">수집 서버 정보</div>

      <el-row class="mr-b15">
        <div class="list form-list">
          <el-form :model="selectCollector" ref="collectorForm" label-position="left">
            <el-form-item label="수집 서버명" label-width="120px">
              <el-input v-model="selectCollector.logCollectorName"></el-input>
            </el-form-item>
            <el-form-item label="수집 서버 주소" label-width="120px">{{ selectCollector.logCollectorIpaddress }}</el-form-item>
            <el-form-item label="등록일" label-width="120px">{{ getDateFormatter(selectCollector.registDatetime) }}</el-form-item>
          </el-form>
        </div>
      </el-row>
      <el-form :model="selectCollector" ref="collectorInfoFrom" label-position="top">
        <el-row>
          <el-form-item label="FTP 설정" label-width="120px">
            <el-select v-model="selectCollector.ftpFlag" @change="setCollectorFTPSetting">
              <el-option v-for="item in ftpSettingList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="아이디" label-width="120px">
              <el-input v-model="selectCollector.ftpId" :disabled="selectCollector.ftpFlag === 'N'"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="비밀번호" label-width="120px">
              <el-input v-model="selectCollector.ftpPassword" type="password" v-show="checkSftpPassword()" :disabled="selectCollector.ftpFlag === 'N'"></el-input>
              <el-button type="primary" @click="onToggleChangePwFlag" v-show="!checkSftpPassword()" :disabled="selectCollector.ftpFlag === 'N'">비밀번호 변경</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <w-collector-pw-change-popup ref="collectorPwChangePopup" :selectCollector="selectCollector"></w-collector-pw-change-popup>
    </div>
    <div slot="footer">
      <el-button size="large" type="solid" @click="updateCollect">저장</el-button>
      <el-button @click="close" size="large">취소</el-button>
    </div>
  </w-sliding-popup>
</template>

<script>
import { isNil, assign, cloneDeep } from 'lodash';
import LogCollectorAPI from '@/api/settings/log/lms-collector-setting';
import msgUtil from '@/utils/message';
import { getDateToString } from '@/utils/date';
import { EMPTY_TEXT } from '@/utils/string';
import { createEncryptTargetData, getRsaEncrypt } from '@/utils/rsa-encrypt';
import WCollectorPwChangePopup from './CollectorPwChangePopup';

export default {
  name: 'WCollectorUpdatePopup',
  props: {
    selectedRow: {
      type: Object,
    },
  },
  components: {
    WCollectorPwChangePopup,
  },
  data() {
    return {
      ftpSettingList: [
        {
          label: '미설정',
          value: 'N',
        },
        {
          label: 'FTP',
          value: 'F',
        },
        {
          label: 'SFTP',
          value: 'S',
        },
      ],
      selectCollector: {
        logCollectorId: '',
        logCollectorName: '',
        logCollectorIpaddress: '',
        registDatetime: '',
        ftpId: '',
        ftpFlag: 'N',
        ftpPasswordFlag: 'N',
      },
    };
  },
  methods: {
    setCollectorFTPSetting(data) {
      if (data === 'N') {
        this.selectCollector.ftpId = null;
        this.selectCollector.ftpPassword = null;
      }
    },
    /**
     * SFTP 비밀번호 체크
     * @author leesy918
     * @return {[type]} [description]
     */
    checkSftpPassword() {
      return this.selectCollector.ftpPasswordFlag === 'N';
    },
    onToggleChangePwFlag() {
      this.$refs.collectorPwChangePopup.open();
    },
    getDateFormatter(value) {
      if (!isNil(value)) {
        return getDateToString(value);
      }
      return EMPTY_TEXT;
    },
    /**
     * 선택한 로그 수집기 설정 수정
     * @author leesy918
     * @return {[type]} [description]
     */
    updateCollect() {
      const action = msgUtil.action.MODIFY;
      const target = '수집기 설정';
      const params = this.selectCollector;
      const encryptTargetData = createEncryptTargetData(params, ['ftpPassword']);
      if (encryptTargetData !== null) {
        getRsaEncrypt(encryptTargetData)
          .then((encryptData) => {
            this.updateCollector(assign(cloneDeep(params), encryptData), action, target);
          })
          .catch((e) => {
            this.$message(msgUtil.getResultMsgData(action, target, false));
            throw new Error(e);
          });
      } else {
        this.updateCollector(params, action, target);
      }
    },
    open() {
      // open
      this.selectCollector = this.selectedRow;
      this.$refs.slidingPopup.visible = true;
    },
    close() {
      this.$refs.slidingPopup.visible = false;
      this.$emit('loadData');
    },
    /**
     * 수집기 정보를 수정한다.
     * @param  {[type]} params [description]
     * @param  {[type]} action [description]
     * @param  {[type]} target [description]
     * @return {[type]}        [description]
     */
    updateCollector(params, action, target) {
      LogCollectorAPI.updateCollectSetting(params)
        .then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(action, target, true));
            this.close();
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        })
        .catch((e) => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
          throw new Error(e);
        });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Collect/CollectionServer/popup/CollectorUpdatePopup.vue